import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot';

const THEME = {
    primary: '#1F2937', secondary: '#3B82F6', success: '#10B981',
    warning: '#F59E0B', danger: '#EF4444', bg: '#F3F4F6'
};

function AdminPlaneacionInventario() {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [estimaciones, setEstimaciones] = useState({});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            // Usamos la ruta de análisis que ya tiene la lógica de ciclos
            const { data } = await api.get('/pedidos/admin/business-analysis', config);
            
            // ✅ VALIDACIÓN: Si tu backend devuelve el objeto completo de análisis, 
            // extraemos solo la lista de clientes.
            const listaClientes = data.topClientes || data; 
            setClientes(Array.isArray(listaClientes) ? listaClientes : []);
        } catch (error) {
            console.error("Error cargando planeación:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleEstimacionChange = (id, dias) => {
        setEstimaciones(prev => ({ ...prev, [id]: dias }));
    };

    if (loading) return <AdminLayout title="Planeación"><div style={{textAlign:'center', padding:50}}>Analizando ciclos de consumo...</div></AdminLayout>;

    if (clientes.length === 0) return (
        <AdminLayout title="Planeación">
            <div style={{textAlign:'center', padding:50, color: THEME.danger}}>
                ⚠️ No se encontraron datos de clientes para analizar. 
                Asegúrate de que existan pedidos entregados en el sistema.
            </div>
        </AdminLayout>
    );

    return (
        <AdminLayout title="📦 Planeación de Demanda e Inventario">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: 20 }}>
                {clientes.map((cliente, idx) => {
                    const diasEstimados = Number(estimaciones[idx] || Math.round(cliente.frecuencia || 7));
                    // Consumo diario estimado
                    const consumoDiario = (Number(cliente.kg) / Number(cliente.frecuencia || 1)) || 0;
                    const cantidadNecesaria = (consumoDiario * diasEstimados).toFixed(1);
                    
                    return (
                        <div key={idx} style={styles.card}>
                            <div style={styles.header}>
                                <div>
                                    <h3 style={styles.clienteNom}>{cliente.nombre}</h3>
                                    <span style={styles.subtext}>Frecuencia: Cada {cliente.frecuencia} días</span>
                                </div>
                                <span style={styles.tag}>{cliente.productoFavorito}</span>
                            </div>

                            <div style={styles.statsGrid}>
                                <div style={styles.statBox}>
                                    <span style={styles.label}>Último Pedido</span>
                                    <div style={styles.value}>{cliente.diasDesdeUltimo} días</div>
                                </div>
                                <div style={styles.statBox}>
                                    <span style={styles.label}>Preferencia</span>
                                    <div style={styles.value}>{cliente.preferencia}</div>
                                </div>
                            </div>

                            <div style={styles.planningArea}>
                                <label style={styles.labelBlack}>📅 ¿En cuántos días estimas el próximo pedido?</label>
                                <input 
                                    type="range" min="1" max="30" 
                                    value={diasEstimados} 
                                    onChange={(e) => handleEstimacionChange(idx, e.target.value)}
                                    style={styles.range}
                                />
                                <div style={{textAlign: 'center', fontWeight: 'bold', color: THEME.secondary, marginTop: 5}}>
                                    Pronóstico a {diasEstimados} días
                                </div>
                            </div>

                            <div style={styles.resultBox}>
                                <span style={styles.label}>Deberías preparar aproximadamente:</span>
                                <div style={{fontSize: 28, fontWeight: '800', color: THEME.primary}}>
                                    {cantidadNecesaria} Kg
                                </div>
                                <p style={{fontSize: 11, margin: 0, color: '#6B7280'}}>
                                    Basado en su consumo histórico de {cliente.kg}kg por ciclo.
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </AdminLayout>
    );
}

const styles = {
    card: { background: 'white', borderRadius: 15, padding: 25, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', border: '1px solid #E5E7EB' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    clienteNom: { margin: 0, fontSize: 18, fontWeight: 'bold', color: '#111827' },
    subtext: { fontSize: 12, color: '#6B7280' },
    tag: { background: '#DBEAFE', color: '#1E40AF', padding: '4px 10px', borderRadius: 20, fontSize: 10, fontWeight: 'bold' },
    statsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginBottom: 20 },
    statBox: { background: '#F9FAFB', padding: 12, borderRadius: 10, textAlign: 'center' },
    label: { fontSize: 10, color: '#9CA3AF', textTransform: 'uppercase', fontWeight: 'bold', display: 'block', marginBottom: 4 },
    labelBlack: { fontSize: 12, color: '#374151', fontWeight: 'bold', marginBottom: 10, display: 'block' },
    value: { fontSize: 16, fontWeight: 'bold', color: '#1F2937' },
    planningArea: { background: '#F0F9FF', padding: 15, borderRadius: 12, marginBottom: 15, border: '1px solid #BAE6FD' },
    range: { width: '100%', cursor: 'pointer', accentColor: THEME.secondary },
    resultBox: { padding: 15, borderRadius: 12, textAlign: 'center', background: '#F3F4F6', border: '1px solid #E5E7EB' }
};

export default AdminPlaneacionInventario;